import { useTranslation } from 'react-i18next';
import { PageHeading } from '../../layout/PageHeading';
import { usePageTitle } from '../../layout/usePageTitle';

/** "Vyhlásenie o prístupnosti" – template text with placeholders to be completed by the operator. */
export function AccessibilityStatementPage() {
  const { t } = useTranslation();
  usePageTitle([t('a11yStatement.title')]);
  const sections = ['scope', 'compliance', 'nonAccessible', 'preparation', 'feedback', 'enforcement'] as const;
  return (
    <div className="govuk-grid-row">
      <div className="govuk-grid-column-two-thirds">
        <PageHeading>{t('a11yStatement.title')}</PageHeading>
        <p className="govuk-body-l">{t('a11yStatement.intro')}</p>
        {sections.map((s) => (
          <section key={s} aria-labelledby={`a11y-${s}`}>
            <h2 className="govuk-heading-m" id={`a11y-${s}`}>
              {t(`a11yStatement.${s}.heading`)}
            </h2>
            <p className="govuk-body">{t(`a11yStatement.${s}.body`)}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
